import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Icon } from 'components';
import { getSummaryPath } from '../../../utils';
import messages from '../messages';

import summariesIcon from 'assets/svg/summaries.svg';
import './categorizerSportSummaries.scss';

interface Props {
    sportId: string;
    outrightsCount: number | undefined;
}

const CategorizerSportSummaries: React.FC<Props> = ({
    sportId,
    outrightsCount,
}) => {
    if (outrightsCount === undefined || outrightsCount < 1) return null;

    return (
        <Link styleName="container" to={getSummaryPath(sportId)}>
            <div styleName="checkbox-placeholder" />

            <Icon glyph={summariesIcon} styleName="icon" />

            <FormattedMessage {...messages.summaries} />

            <div styleName="counter">{outrightsCount}</div>
        </Link>
    );
};

export default CategorizerSportSummaries;
